/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { StartDateType } from './';
import {
    StartDateTypeFromJSON,
    StartDateTypeFromJSONTyped,
    StartDateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChosenStartDateApi
 */
export interface ChosenStartDateApi extends StartDate {
    /**
     * 
     * @type {Date}
     * @memberof ChosenStartDateApi
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ChosenStartDateApi
     */
    flexibility: ChosenStartDateApiFlexibilityEnum;
    /**
     * 
     * @type {Date}
     * @memberof ChosenStartDateApi
     */
    earliestStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChosenStartDateApi
     */
    latestStartDate?: Date;
}


/**
 * @export
 */
export const ChosenStartDateApiFlexibilityEnum = {
    NotFlexible: 'NOT_FLEXIBLE',
    MoreOrLess2Days: 'MORE_OR_LESS_2_DAYS',
    MoreOrLess1Week: 'MORE_OR_LESS_1_WEEK',
    MoreOrLess1Month: 'MORE_OR_LESS_1_MONTH'
} as const;
export type ChosenStartDateApiFlexibilityEnum = typeof ChosenStartDateApiFlexibilityEnum[keyof typeof ChosenStartDateApiFlexibilityEnum];


/**
 * Check if a given object implements the ChosenStartDateApi interface.
 */
export function instanceOfChosenStartDateApi(value: object): value is ChosenStartDateApi {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('flexibility' in value) || value['flexibility'] === undefined) return false;
    return true;
}

export function ChosenStartDateApiFromJSON(json: any): ChosenStartDateApi {
    return ChosenStartDateApiFromJSONTyped(json, false);
}

export function ChosenStartDateApiFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChosenStartDateApi {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateFromJSONTyped(json, ignoreDiscriminator),
        'date': (new Date(json['date'])),
        'flexibility': json['flexibility'],
        'earliestStartDate': json['earliestStartDate'] == null ? undefined : (new Date(json['earliestStartDate'])),
        'latestStartDate': json['latestStartDate'] == null ? undefined : (new Date(json['latestStartDate'])),
    };
}

export function ChosenStartDateApiToJSON(value?: ChosenStartDateApi | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateToJSON(value, true),
        'date': ((value['date']).toISOString().substring(0,10)),
        'flexibility': value['flexibility'],
        'earliestStartDate': value['earliestStartDate'] == null ? undefined : ((value['earliestStartDate']).toISOString()),
        'latestStartDate': value['latestStartDate'] == null ? undefined : ((value['latestStartDate']).toISOString()),
    };
}

